<template>
  <form class="form-horizontal text-left" @submit.prevent="submitForm">
    <div
      class="modal-content"
      style="width: inherit; height: inherit; margin: 0 auto"
    >
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 id="modal_title" class="modal-title">Edit Manufacturer</h4>
      </div>

      <div class="modal-body">
        <div class="well p-5">
          <div class="row">
            <div class="col-md-12">
              <div v-if="manufacturer">
                <h4>Manufacturer details</h4>
                <table style="margin-bottom: 2rem">
                  <tbody>
                    <tr>
                      <th class="manufacturer-info-header">Company name</th>
                      <td>{{ manufacturer.name }}</td>
                    </tr>
                    <tr>
                      <th class="manufacturer-info-header">Primary email</th>
                      <td v-if="manufacturer.email">
                        {{ manufacturer.email }}
                      </td>
                      <td v-else class="text-danger">Missing</td>
                    </tr>
                    <tr>
                      <th class="manufacturer-info-header">Primary phone</th>
                      <td v-if="manufacturer.phone">
                        {{ manufacturer.phone }}
                      </td>
                      <td v-else class="text-danger">Missing</td>
                    </tr>
                    <tr>
                      <th class="manufacturer-info-header">Website URL</th>
                      <td v-if="manufacturer.website_url">
                        {{ manufacturer.website_url }}
                      </td>
                      <td v-else class="text-danger">Missing</td>
                    </tr>
                    <tr>
                      <th class="manufacturer-info-header">Invoice Terms</th>
                      <td v-if="manufacturer.terms.name">
                        {{ manufacturer.terms.name }}
                      </td>
                      <td v-else class="text-danger">Missing</td>
                    </tr>
                  </tbody>
                </table>
                <small>
                  The details in this section are provided by QuickBooks and
                  cannot be modified here. If any changes are necessary, those
                  changes
                  <em>must</em> be made within QuickBooks Online.
                </small>
              </div>
            </div>
          </div>
        </div>

        <br />

        <div class="well p-5">
          <div class="row" style="margin: 0">
            <div class="col-md-12">
              <h4 style="margin-left: -15px">Inside Sales Contact Details</h4>
              <div class="form-group">
                <label for="inside_sales_contact_name">Contact Name*</label>
                <input
                  id="inside_sales_contact_name"
                  v-model="inside_sales_contact_name"
                  name="manufacturer[inside_sales_contact_name]"
                  class="form-control"
                  type="text"
                  required
                />
                <div
                  v-if="errors['manufacturer.inside_sales_contact_name']"
                  class="py-2"
                >
                  <small class="text-danger">
                    {{ errors["manufacturer.inside_sales_contact_name"][0] }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label for="inside_sales_contact_email">Contact Email*</label>
                <input
                  id="inside_sales_contact_email"
                  v-model="inside_sales_contact_email"
                  name="manufacturer[inside_sales_contact_email]"
                  class="form-control"
                  type="text"
                  required
                />
                <div
                  v-if="errors['manufacturer.inside_sales_contact_email']"
                  class="py-2"
                >
                  <small class="text-danger">
                    {{ errors["manufacturer.inside_sales_contact_email"][0] }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label for="inside_sales_contact_phone">Contact Phone*</label>
                <input
                  id="inside_sales_contact_phone"
                  v-model="inside_sales_contact_phone"
                  v-mask="'(###) ###-####'"
                  name="manufacturer[inside_sales_contact_phone]"
                  class="form-control"
                  type="text"
                  required
                />
                <div
                  v-if="errors['manufacturer.inside_sales_contact_phone']"
                  class="py-2"
                >
                  <small class="text-danger">
                    {{ errors["manufacturer.inside_sales_contact_phone"][0] }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="submit"
          class="btn btn-primary"
          :disabled="submitDisabled || submitting"
        >
          Submit
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import phoneNumber from "../../../inputMasks/phoneNumber";

export default {
  props: {
    manufacturer: {
      type: Object,
      required: true,
    },
    submitUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      inside_sales_contact_name: null,
      inside_sales_contact_email: null,
      inside_sales_contact_phone: null,
      errors: [],
      missingFields: [],
      submitting: false,
      phoneMask: phoneNumber(),
    };
  },

  computed: {
    submitDisabled() {
      return !this.isModified();
    },
  },

  mounted() {
    this.inside_sales_contact_name = this.manufacturer.inside_sales_contact_name;
    this.inside_sales_contact_email = this.manufacturer.inside_sales_contact_email;
    this.inside_sales_contact_phone = this.manufacturer.inside_sales_contact_phone;
  },

  methods: {
    isModified() {
      return (
        this.inside_sales_contact_name !==
          this.manufacturer.inside_sales_contact_name ||
        this.inside_sales_contact_email !==
          this.manufacturer.inside_sales_contact_email ||
        this.inside_sales_contact_phone !==
          this.manufacturer.inside_sales_contact_phone
      );
    },

    submitForm() {
      if (!this.isModified()) {
        return;
      }

      this.submitting = true;

      this.$http
        .post(this.submitUrl, {
          _method: "PUT",
          manufacturer: {
            inside_sales_contact_name: this.inside_sales_contact_name,
            inside_sales_contact_email: this.inside_sales_contact_email,
            inside_sales_contact_phone: this.inside_sales_contact_phone,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            window.location = res.data;
          } else {
            throw new Error("Something unexpected happened...");
          }
        })
        .catch((e) => {
          if (e.response) {
            this.errors = e.response.data.errors;
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style scoped>
.manufacturer-info-header {
  text-align: right;
  vertical-align: top;
  padding-bottom: 0.5rem;
  padding-right: 1rem;
}
.address-paragraph {
  margin: 0;
}
</style>
